// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type {
	ExtendedError,
	StoreBaseContainerProps,
	StoreTeamsContainerProps,
} from '../../../../common/types/index.tsx';
import { createDataResponse, createErrorResponse } from '../../../../common/utils/store/index.tsx';
import { multiplePromiseSettler } from '../../utils/index.tsx';
import * as endpoints from '../endpoints/index.tsx';
import type { TeamsState } from '../types.tsx';

const getTeams =
	(): Action<TeamsState, StoreTeamsContainerProps> =>
	({ setState, getState }, { orgId, siteId, accountId }) => {
		if (!orgId) {
			throw new Error('TeamsContainer-actions-getTeams-orgId must be defined to search teams');
		}

		if (!accountId) {
			const error: ExtendedError = new Error(
				'TeamsContainer-useSyncContainerProps-atlassianAccountId must be defined to search teams',
			);

			error.skipSentry = true;

			throw error;
		}

		const state = getState();

		setState({ teams: { data: state.teams.data, error: null, loading: true } });

		return endpoints
			.searchTeamsEndpoint({ orgId, siteId, accountId })
			.then((res) => setState({ teams: createDataResponse(res) }))
			.catch((err) => {
				setState({ teams: createErrorResponse(err) });
				throw err;
			});
	};

const initialize =
	(): Action<TeamsState, StoreBaseContainerProps, Promise<PromiseSettledResult<void>[]>> =>
	({ dispatch }) =>
		Promise.allSettled([dispatch(getTeams())]).then(multiplePromiseSettler);

export const actions = {
	getTeams,
	initialize,
};
